import PropTypes from 'prop-types';
import cn from 'classnames';

import { DESIGN_REVIEW_STATUS } from 'utlis/constants';

const getNpsBorderColor = score => {
  if (score > 40) {
    return '#3EDA6C';
  }
  if (score >= 0) {
    return '#FFB900';
  }

  return '#F75A5F';
};

const getNpsTextColor = score => {
  if (score > 40) {
    return '#1A4A28';
  }
  if (score >= 0) {
    return '#7B3306';
  }

  return '#72181B';
};

const NpsBadge = ({ review }) => {
  const isCompleted = review.review_status === DESIGN_REVIEW_STATUS.DONE;
  const rawScore = review.extra_data?.post_processes?.overview?.data?.score_assessment?.score;

  let scoreDisplay = rawScore;

  if (rawScore != null) {
    if (typeof rawScore === 'string' && rawScore.trim() !== '') {
      scoreDisplay = rawScore.trim().replace(/^\+/, '');
    }
  }

  const scoreNumeric = scoreDisplay != null ? Number(scoreDisplay) : NaN;
  const score = isFinite(scoreNumeric)
    ? String(scoreDisplay).replace(/^[-\u2212]/, '-')
    : null;
  const haveScore = isCompleted && score != null;

  return (
    <div className="flex items-center">
      <div
        className={cn(
          'flex flex-row justify-center items-center w-[26px] h-[26px] rounded-full border flex-shrink-0',
          haveScore ? 'bg-white' : 'bg-[#F8F9FB] border-[#E1E4E8]'
        )}
        style={haveScore ? { borderColor: getNpsBorderColor(scoreNumeric) } : undefined}
      >
        <span
          className={cn(
            'font-inter text-[11px] leading-4 tracking-tight',
            haveScore ? 'whitespace-nowrap' : 'text-[#606776]'
          )}
          style={haveScore ? { color: getNpsTextColor(scoreNumeric) } : undefined}
        >
          {haveScore ? score : '-'}
        </span>
      </div>
    </div>
  );
};

NpsBadge.propTypes = {
  review: PropTypes.object.isRequired,
};

export default NpsBadge;
